import { Injector } from "@angular/core";
import { AuthService } from "../../service/auth-service/auth-service.service";
import { TreeNodeImportedMessagesList } from "../Node/Art57Node/ListEntity/TreeNodeImportedMessagesList";
import { BaseNode } from "../Node/BaseNode";
import { BulkUpdateList } from "../Node/WebTraderNode/ListEntity/BulkUpdateList";
import { QueryNodeInBox } from "../Node/WebTraderNode/Query/QueryNodeInBox";
import { QueryNodeOutBox } from "../Node/WebTraderNode/Query/QueryNodeOutBox";
import { QueryNodeMessageBox } from "../Node/WebTraderNode/QueryNodeMessageBox";
import { Section } from "./Section";
import { QueryNodeToEudravigilance } from "../Node/WebTraderNode/Query/QueryNodeToEudravigilance";
import { QueryNodeFromEudravigilance } from "../Node/WebTraderNode/Query/QueryNodeFromEudravigilance";

export class WebTraderSection extends Section {

    treeView: BaseNode[] = [];
    selectedNode!: BaseNode;
    
    constructor(
        injector: Injector,
        private authService: AuthService) {
        super(injector);
    }

    override resetSection(): void {
        // do a section reset
        const importedMessages = this.ioc!.get(TreeNodeImportedMessagesList);
        const bulkUpdate = this.ioc!.get(BulkUpdateList);
        const inBox = this.ioc!.get(QueryNodeInBox);
        const outBox = this.ioc!.get(QueryNodeOutBox);
        const toEudravigilance = this.ioc!.get(QueryNodeToEudravigilance)
        const fromEudravigilance = this.ioc!.get(QueryNodeFromEudravigilance)

        //this.treeView.splice(0,this.treeView.length); // force to clean structure if it has any nodes

        while (this.treeView.length > 0) {
            this.treeView.pop();
        }
        this.treeView.push(inBox);
        this.treeView.push(outBox);
        //Added the subsection 'To Eudravigilance' when the user allow to EMA Organisation.
        this.isEMA() ? this.treeView.push(toEudravigilance): '';
        //Added the subsection 'From Eudravigilance' when the user allow to EMA Organisation.
        this.isEMA() ? this.treeView.push(fromEudravigilance): '';
        this.treeView.push(importedMessages);
        if (this.isAllowedBulkUpdateTreeItem()) {
            this.treeView.push(bulkUpdate);
        }
        (inBox as QueryNodeMessageBox).reset();
        (outBox as QueryNodeMessageBox).reset();
        (toEudravigilance as QueryNodeMessageBox).reset();
        (fromEudravigilance as QueryNodeFromEudravigilance).reset();
        importedMessages.reset();
        bulkUpdate.reset();

        this.selectedNode = inBox;
        this.selectedNode.data.model = undefined;
    }

    isAllowedBulkUpdateTreeItem(): boolean {
        return this.authService.hasAnyRole("EVH_WEBTRADER_BULKUPDATE");
    }

    isEMA(): boolean {
        return this.authService.isEMAOrganisation();
    }
}